import {Input} from "./Input.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";
import {InputValidator} from "../../util/input-validate/inputValidation.js";
import {DEFAULT_SUB_DOMAIN} from "../../constant.js";


export class CompanyNameInput extends Input {

    template() {
        const {addClassName = ""} = this.$props;
        return `
            <div class="interactive-form-wrap js-interactive-form-wrap">
                <input type="text"
                        autocomplete="off"
                          id="teamNameInput"
                           class="js-name-input interactive-form-input ${addClassName}"
                           placeholder=""
                           data-required-yn="Y"
                           maxlength="50" 
                           data-over-msg="${i18next.t(login.inputAlert, {val: 50})}"
                           data-empty-msg=" ${i18next.t(login.common.enter, {val: $t(login.companyName)})}"
                           data-valid="name"
                           data-un-valid-msg="${i18next.t(login.recheckCompanyName)}">
                <span class="interactive-form-placeholder">${i18next.t(login.companyName)}</span>
            </div>
            <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
            </p>
            `
    }

    getInputSelector() {
        return "#teamNameInput";
    }


    getSubDomain() {
        const companyName = this.getInputValue();
        if (Mutil.empty(companyName)) {
            return;
        }
        const isValidCompanyUrl = InputValidator.isValidTeamUrl(companyName);
        return isValidCompanyUrl ? companyName : DEFAULT_SUB_DOMAIN;
    }
}
